import { render } from "./RegionalRepresentative.vue?vue&type=template&id=537260fc&scoped=true"
import script from "./RegionalRepresentative.vue?vue&type=script&lang=js"
export * from "./RegionalRepresentative.vue?vue&type=script&lang=js"

import "./RegionalRepresentative.vue?vue&type=style&index=0&id=537260fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-537260fc"]])

export default __exports__